import request from '@/utils/request'

/**
 * 签到管理 API
 */
export default {
  /**
   * 批量签到
   */
  batchSignIn(data) {
    return request({
      url: '/education/sign-in/batch',
      method: 'post',
      data
    })
  },

  /**
   * 分页查询签到记录
   */
  pageQuery(data) {
    return request({
      url: '/education/sign-in/page',
      method: 'post',
      data
    })
  },

  /**
   * 查询某学生今日是否已签到
   */
  isTodaySigned(studentId) {
    return request({
      url: '/education/sign-in/today/' + studentId,
      method: 'get'
    })
  },

  /**
   * 批量查询今日签到状态
   */
  todayStatusBatch(studentIds) {
    return request({
      url: '/education/sign-in/today-status',
      method: 'post',
      data: studentIds
    })
  },

  /**
   * 重新推送签到消息
   */
  retryPush(id) {
    return request({
      url: '/education/sign-in/retry-push/' + id,
      method: 'post'
    })
  },

  /**
   * 今日签到统计（按筛选条件汇总全部学生）
   */
  todayStats(data) {
    return request({
      url: '/education/sign-in/today-stats',
      method: 'post',
      data
    })
  }
}
